import { setErrorDialog, serverUrl, getheader, getMethodByCallBack, cacheTypes, postMethodByCallBack, translateError } from "./CommonFunctions";

export function updateUser(data, fn) {
    return dispatch => {
        dispatch({
            type: "LOADING",
            data: true
        });
        fetch(serverUrl + "api/UserAPI/UpdateUser", {
            headers: getheader(),
            body: JSON.stringify(data),
            method: "POST"
        }).then(res => res.json())
            .then(res => {
                dispatch({
                    type: "LOADING",
                    data: false
                });
                if (res.Message) {
                    if (res.Message === "DuplicateUserName") {
                        setErrorDialog(dispatch, "کاربری دیگری با این نام کاربری وجود دارد", "اطلاعات کاربر");
                    }
                    else {
                        setErrorDialog(dispatch, translateError(res.Message), "اطلاعات کاربر");
                    }
                }
                else if (res === 200) {
                    setErrorDialog(dispatch, "عملیات با موفقیت انجام شد", "اطلاعات کاربر");
                    if (fn) { fn() }

                }
                else {
                    setErrorDialog(dispatch, "اشکال در انجام عملیات", "اطلاعات کاربر");
                }
            }).catch(e => {
                console.log("[UpdateUser]", e);
                dispatch({
                    type: "LOADING",
                    data: false
                });
            })

    }
}
export function getPageFieldList(pageName) {
    return dispatch => {
        fetch(serverUrl + `api/AccountAPI/GetPageFieldList?pageName=${pageName}`, {
            method: "GET",
            cache: "default",
            headers: getheader()
        }).then(res => res.json())
            .then(res => {
                if (res.Message) {
                    res = null;
                }
                return dispatch({
                    type: "PAGE_FIELD_LIST",
                    data: res
                });
            }).catch(e => {
                console.log("[PAGE_FIELD_LIST]", e)
                return dispatch({
                    type: "PAGE_FIELD_LIST",
                    data: null
                });
            });
    }
}
export function getUserList(name, onGetList, stageID) {
    if (!onGetList) {
        return dispatch => {
            dispatch({
                type: "GET_USER_LIST",
                data: "PENDING"
            });
            if (!name) {
                name = "";
            }
            fetch(serverUrl + `api/UserAPI/SearchUser?Name=${name}&stageID=${stageID}`, {
                headers: getheader(),
                method: "GET"
            }).then(res => res.json())
                .then(res => {
                    if (res.Message) {
                        res = null;
                    }
                    return dispatch({
                        type: "GET_USER_LIST",
                        data: res
                    });
                })
        }
    }
    else {
        getMethodByCallBack(`api/UserAPI/SearchUser?Name=${name ?? ""}&stageID=${stageID}`, cacheTypes.NoCache, onGetList, "SearchUser");
    }
}
export function setUserPop(status) {
    return dispatch => {
        return dispatch({
            type: "USER_POP",
            data: status
        });
    }
}
export function setSelectedUserPop(status) {
    return dispatch => {
        return dispatch({
            type: "SELECTED_USER_POP",
            data: status
        });
    }
}
export function referDocument(data, fn) {
    postMethodByCallBack("api/UserDashboardAPI/ReferDocument", data, fn, "ReferDocument");
}
export function getRefersCountByDoc(onGet) {
    getMethodByCallBack("api/UserDashboardAPI/GetUnreadRefersCountByDocument", cacheTypes.NoCache, onGet, "GetUnreadRefersCountByDocument");
}
export function getDocumentReferList(hardCode, refByMe, showDone, rejected, onGet, documentID) {
    if (Number(documentID) > 0) {
        getMethodByCallBack(`api/UserDashboardAPI/GetDocumentReferList?hardCode=${hardCode}&documentID=${documentID}`, cacheTypes.NoCache, onGet, "GetDocumentReferList");
    }
    else {
        getMethodByCallBack(`api/UserDashboardAPI/GetDocumentReferList?hardCode=${hardCode}&refByMe=${refByMe}&showDone=${showDone}&rejected=${rejected}`, cacheTypes.NoCache, onGet, "GetDocumentReferList");
    }
}
/**
 * 
 * @param {boolean} refByMe 
 * @param {boolean} showDone 
 * @param {boolean} rejected 
 * @param {function} onGet 
 */
export function getServiceReferList(refByMe, showDone, rejected, onGet) {
    getMethodByCallBack(`api/UserDashboardAPI/GetServiceReferList?refByMe=${refByMe}&showDone=${showDone}&rejected=${rejected}`, cacheTypes.NoCache, onGet, "GetServiceReferList");
}
export function setReferToRead(referID, onSet) {
    getMethodByCallBack(`api/UserDashboardAPI/SetReferToRead?referID=${referID}`, cacheTypes.NoCache, onSet, "SetReferToRead");
}
export function setReferToUnRead(referID, onSet) {
    getMethodByCallBack(`api/UserDashboardAPI/SetReferToUnRead?referID=${referID}`, cacheTypes.NoCache, onSet, "SetReferToRead");
}
export function exitDocumentFromDashboard(referID, onExit) {
    getMethodByCallBack(`api/UserDashboardAPI/ExitDocumentFromDashboard?referID=${referID}`, cacheTypes.NoCache, onExit, "ExitDocumentFromDashboard");
}
export function rejectRefer(referID, rejectDesc, onReject) {
    postMethodByCallBack(`api/UserDashboardAPI/RejectRefer?refID=${referID}`, rejectDesc, onReject, "RejectRefer");
}
export function monitorRemoveMonitor(referID, monitor, onMonitor) {
    getMethodByCallBack(`api/UserDashboardAPI/MonitorRemoveMonitor?referID=${referID}&monitor=${monitor}`, cacheTypes.NoCache, onMonitor, "MonitorRemoveMonitor");
}
export function getMonitorReferList(onGet) {
    getMethodByCallBack(`api/UserDashboardAPI/GetMonitorReferList`, cacheTypes.NoCache, onGet, "GetMonitorReferList");
}